require('./index.jade')
moment = require('moment')
$ = require('jquery')
_ = require('lodash')

TimelineCreateEventDirective = ($filter ,$translate) ->
  restrict: "EA"
  replace: true
  templateUrl: "group-timeline/timeline-create-event-directive/index.jade"
  scope:
    data: '=data'
    submit: '&submitReaction'
  link: (scope) ->
    now = moment()
    scope.score_cards = scope.data.user.score_cards
    if scope.data.user.score_card
      scope.score_cards = _.union(scope.score_cards , [scope.data.user.score_card])
    scope.displayName = (user) ->
      fName = user.first_name ? ''
      lName = user.last_name ? ''
      if fName + lName == ''
        return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')
      if /^ja/i.test $translate.preferredLanguage()
        return lName + " " + fName
      return fName + " " + lName

    scope.displayEvent = (groupEvent) ->
      if groupEvent.active
        "<a href='/group-event/#{groupEvent.id}/ranking'>#{groupEvent.name}</a>"
      else
        groupEvent.name

    scope.displayYear = (time) ->
      displayStr = moment(time)
      strFormat = ''
      if /^ja/i.test $translate.preferredLanguage()
        if displayStr.year() != now.year()
          strFormat = 'YYYY年MM月DD日 HH:mm'
        else
          strFormat = 'MM月DD日 HH:mm'
      else
        if displayStr.year() != now.year()
          strFormat = 'YYYY-MM-DD HH:mm'
        else
          strFormat = 'MM-DD HH:mm'
      displayStr.format(strFormat)

    setUserReaction = (type , userReaction) ->
      userReaction.good = if type == 'good' then  !userReaction.good  else false
      userReaction.awesome = if type == 'awesome' then  !userReaction.awesome  else false
      userReaction.bad = if type == 'bad' then  !userReaction.bad  else false

    setCountReaction = (oldReaction , newReaction , data) ->
      if oldReaction.good != newReaction.good
        data.good += if newReaction.good then 1 else -1
      if oldReaction.awesome != newReaction.awesome
        data.awesome += if newReaction.awesome then 1 else -1
      if oldReaction.bad != newReaction.bad
        data.bad += if newReaction.bad then 1 else -1

    scope.btnReactionPress = (type , data) ->
      oldReaction =
        good : data.user_reaction.good
        awesome : data.user_reaction.awesome
        bad : data.user_reaction.bad
      setUserReaction(type , data.user_reaction)
      setCountReaction(oldReaction , data.user_reaction , data.reactions)
      param =
        paramReaction :
          type: type
          group_timeline_id: data.id

      scope.submit(param)

    scope.getPostTypeName = (type) ->
      switch type
        when 'upload_score_card'
          if scope.score_cards.length > 1
            '_GROUP_TIMELINE.SUBMIT_SCORES_TITLE'
          else
            '_GROUP_TIMELINE.SUBMIT_SCORE_TITLE'
        when 'create_event'
          '_GROUP_TIMELINE.CREATE_EVENT_TITLE'
        when 'update_event'
          '_GROUP_TIMELINE.UPDATE_EVENT_TITLE'
        when 'delete_event'
          '_GROUP_TIMELINE.DELETE_EVENT_TITLE'
        else '_GROUP_TIMELINE.CREATE_EVENT_TITLE'

    scope.getTextOfAvatar = ->
      $avatarElement = $(".avatar-for-#{scope.data.user.id} .avatar-image-text:not(.is-small)")

      if scope.data.user.display_text_avatar.length == 1
        $avatarElement.removeClass('two-characters')
        $avatarElement.addClass('one-character')
      else
        $avatarElement.removeClass('one-character')
        $avatarElement.addClass('two-characters')
      scope.data.user.display_text_avatar

    scope.isAvatarColor = ->
      scope.data.user.avatar_image_path?.indexOf('avatar_color') > -1

TimelineCreateEventDirective.$inject = [
  '$filter'
  '$translate'
]

module.exports = TimelineCreateEventDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/timeline-create-event-directive/timeline-create-event-directive.coffee